import styled from 'styled-components';

export const CosumerUnitsDigestContainer = styled.div`
  background-color: ${(props) => props.theme.color.bg.primary};
  grid-area: consumerunitsdigest;
`;

export const Title = styled.h4`
  font-family: ${(props) => props.theme.font.title.family};
  font-size: ${(props) => props.theme.font.title.size.h4};
  line-height: ${(props) => props.theme.font.title.lineHeight.h4};
  color: ${(props) => props.theme.color.ui.orange};
`;

export const Value = styled.div`
  font-family: Montserrat;
  font-size: 20px;
  color: ${(props) => props.theme.color.ui.orange};
  font-weight: 700;
  line-height: normal;
  display: inline-block;
`;

export const Rate = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  top: -2px;
  font-family: Poppins;
  font-size: 12px;
  svg {
    &.rotate {
      transform: rotate(180deg);
    }
  }
  &.negative {
    color: ${(props) => props.theme.color.text.danger};
    svg {
      path {
        fill: ${(props) => props.theme.color.text.danger};
      }
    }
  }
  &.positive {
    color: ${(props) => props.theme.color.text.success};
    svg {
      path {
        fill: ${(props) => props.theme.color.text.success};
      }
    }
  }
  .ref {
    margin-left: 6px;
    color: ${(props) => props.theme.color.text.quaternary};
  }
  svg {
    margin: 0 8px;
  }
`;

export const Subtitle = styled.div`
  color: ${(props) => props.theme.color.text.quaternary};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-family: ${(props) => props.theme.font.body.family};
  line-height: ${(props) => props.theme.font.body.lineHeight.small};
`;
